import { ActivatedRouteSnapshot, RouterStateSnapshot, Routes } from '@angular/router';
import { OktaAuthGuard, OktaCallbackComponent } from '@okta/okta-angular';
import { AfGuardFnLicensed, AfGuardFnOktaCallbackErrorCheck, AfGuardFnPageAccess } from '../guards';
import { CanDeactivateDealCompGuard } from './features/prob/guards';

import { PagePbHomeComponent } from './features/prob/pages/page-pb-home/page-pb-home.component';
import { PageNotFoundComponent, PageNotAuthorizedComponent, PageNoLicenseComponent } from './modules/fwcore';

import { PagePbDealDetailComponent } from './features/prob/pages';
import { PagePbLoginV2Component } from './features/prob/pages/page-pb-login-v2/page-pb-login-v2.component';

export const routes: Routes = [
  { path: '', redirectTo: 'login', pathMatch: 'full' },

  { path: 'home', component: PagePbHomeComponent, canActivate: [OktaAuthGuard, AfGuardFnLicensed] },

  { path: 'login', component: PagePbLoginV2Component  },
  { path: 'login/callback', component: OktaCallbackComponent, canActivate: [AfGuardFnOktaCallbackErrorCheck] },

  {
    path: 'admin',
    loadChildren: () =>
      import('./features/admin/admin.routes').then(r => r.ADMIN_ROUTES)
  },

  {
    path: 'admin/prob',
    loadChildren: () =>
      import('./features/prob/prob-admin.routes').then(r => r.PROB_ADMIN_ROUTES)
  },

  // ProBenchmark Analytics (Analytics > Usage analytics), lazy-loaded.
  {
    path: 'analytics',
    loadChildren: () =>
      import('./features/analytics/analytics.routes').then(r => r.ANALYTICS_ROUTES)
  },

  {
    path: 'scenarios',
    loadChildren: () =>
      import('./features/prob/prob-deals.routes').then(r => r.PROB_DEALS_ROUTES)
  },
  {
    path: 'scenario'
    , loadComponent: () => import('./../app/features/prob/pages/page-pb-deal-detail/page-pb-deal-detail.component').then(c => c.PagePbDealDetailComponent)
    , canActivate: [OktaAuthGuard, (route: ActivatedRouteSnapshot) => AfGuardFnPageAccess(route)]
    , canDeactivate: [(component: PagePbDealDetailComponent, currentRoute: ActivatedRouteSnapshot, currentState: RouterStateSnapshot, nextState: RouterStateSnapshot) => CanDeactivateDealCompGuard(component, currentRoute, currentState, nextState)]
    , data: {
      breadcrumb: 'Scenario Detail'
      , heading: 'Scenario'
    }
  },

  // In-product Help. One parameter covers both URL forms - a section slug such as
  // 'glossary', or an article id for a deep link - so a section added in the CMS is
  // reachable without a route change. Guarded by OktaAuthGuard only: Help is
  // reader-facing content and needs no page-access grant, unlike the CMS to come.
  {
    path: 'help'
    , loadComponent: () => import('./features/prob/pages/page-pb-help/page-pb-help.component').then(c => c.PagePbHelpComponent)
    , canActivate: [OktaAuthGuard]
    , data: {
      breadcrumb: 'Help'
      , heading: 'Help Centre'
    }
  },
  {
    path: 'help/:ref'
    , loadComponent: () => import('./features/prob/pages/page-pb-help/page-pb-help.component').then(c => c.PagePbHelpComponent)
    , canActivate: [OktaAuthGuard]
    , data: {
      breadcrumb: 'Help'
      , heading: 'Help Centre'
    }
  },

  { path: 'error/404', component: PageNotFoundComponent },
  { path: 'error/not-authorized', component: PageNotAuthorizedComponent },
  { path: 'not-authorized', redirectTo: 'error/not-authorized' },
  { path: 'no-license', component: PageNoLicenseComponent },

  { path: '**', redirectTo: 'error/404' }
];
